(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart page: +/- stepper and direct edits submit the cart form (updates[]).
  // NOTE: no Liquid inside this block — it is bundled as plain JS on every page.
  function isshojpInitCart() {
    var form = document.getElementById('cart-form');
    if (!form) return;
    var sync = form.querySelector('[data-cart-attr-sync]');
    if (sync && window.fetch) {
      var attrs = {};
      form.querySelectorAll('[data-cart-attr]').forEach(function (i) {
        var m = i.name.match(/^attributes\[(.*)\]$/);
        if (m) attrs[m[1]] = i.value;
      });
      fetch(sync.getAttribute('data-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }
    var contact = form.querySelector('[data-cart-contact]');
    if (contact) isshojpInitContact(form, contact);
    // Quantity changes go through the formnovalidate update button so the
    // required contact fields only block the checkout button.
    var updateBtn = form.querySelector('.cart__update-btn');
    var submit = function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(updateBtn || undefined);
      else form.submit();
    };
    form.querySelectorAll('.cart-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.cart-qty__input');
        var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        submit();
      });
    });
    form.querySelectorAll('.cart-qty__input').forEach(function (input) {
      input.addEventListener('change', submit);
    });
  }
  // Required LINE / WhatsApp contact (cart attributes). Saved as the shopper
  // types so it survives leaving the page; also posted with the checkout submit.
  function isshojpInitContact(form, box) {
    var radios = box.querySelectorAll('input[type="radio"]');
    var idInput = box.querySelector('[data-contact-id]');
    var idLabel = box.querySelector('[data-id-label]');
    var attrName = function (el) {
      var m = el.name.match(/^attributes\[(.*)\]$/);
      return m ? m[1] : el.name;
    };
    var app = function () {
      var c = box.querySelector('input[type="radio"]:checked');
      return c ? c.value : '';
    };
    var validate = function () {
      var a = app();
      radios.forEach(function (r) { r.setCustomValidity(a ? '' : box.getAttribute('data-msg-app')); });
      var v = idInput.value.trim();
      var msg = '';
      if (!v) {
        msg = box.getAttribute('data-msg-id');
      } else if (a === 'WhatsApp') {
        var digits = v.replace(/\D/g, '').length;
        if (!/^[+\d\s().-]+$/.test(v) || digits < 7 || digits > 15) msg = box.getAttribute('data-msg-wa');
      }
      idInput.setCustomValidity(msg);
    };
    var refresh = function () {
      var a = app();
      var key = a === 'WhatsApp' ? 'whatsapp' : a === 'LINE' ? 'line' : 'any';
      idLabel.textContent = idLabel.getAttribute('data-' + key);
      idInput.placeholder = idInput.getAttribute('data-ph-' + key);
      idInput.setAttribute('inputmode', a === 'WhatsApp' ? 'tel' : 'text');
      idInput.setAttribute('autocomplete', a === 'WhatsApp' ? 'tel' : 'off');
      validate();
    };
    // One request at a time, always sending the latest values, so a slow
    // older request can never overwrite a newer one.
    var timer, inflight = false, again = false;
    var flush = function () {
      if (!window.fetch) return;
      if (inflight) { again = true; return; }
      inflight = true;
      var attrs = {};
      attrs[attrName(radios[0])] = app();
      attrs[attrName(idInput)] = idInput.value.trim();
      fetch(box.getAttribute('data-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true
      }).catch(function () {}).then(function () {
        inflight = false;
        if (again) { again = false; flush(); }
      });
    };
    var save = function () {
      clearTimeout(timer);
      timer = setTimeout(flush, 400);
    };
    form.addEventListener('submit', function () { clearTimeout(timer); again = false; });
    radios.forEach(function (r) {
      r.addEventListener('change', function () { refresh(); save(); });
    });
    idInput.addEventListener('input', function () { validate(); save(); });
    form.addEventListener('invalid', function () { box.setAttribute('data-tried', ''); }, true);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', isshojpInitCart);
  else isshojpInitCart();

  } catch(e) { console.error(e); }
})();
})();
